import { getHoroscopeMatches } from "../../../api/api";
import MatchProfilePage from "./MatchProfilePage";

const HoroscopeProfilePage = () => (
  <MatchProfilePage
    title="Horoscope Matches"
    fetchProfiles={getHoroscopeMatches}
  />
);

export default HoroscopeProfilePage;
